// Desglose de un cobro registrado: cada forma de pago con su comprobante y monto, y el total cobrado.
import { cn } from '@/lib/cn';
import { formatMoneyCents } from '@/shared/lib/format/money';
import {
    PAYMENT_LINE_LABEL,
    paymentLinesTotalCents,
    paymentReceiptLabel,
    type PaymentLine,
} from '@/shared/lib/format/salePaymentLines';

export interface PaymentBreakdownProps {
    lines: readonly PaymentLine[];
    className?: string;
}

export function PaymentBreakdown({ lines, className }: PaymentBreakdownProps) {
    return (
        <div className={cn('flex flex-col gap-1.5', className)}>
            {lines.length > 1 && (
                <span className="text-[10px] uppercase tracking-[0.06em] text-muted-foreground">
                    Cobro en {lines.length} formas
                </span>
            )}
            <ul className="overflow-hidden rounded-lg border border-border bg-card">
                {lines.map((line, index) => (
                    <li
                        key={`${line.method}-${String(index)}`}
                        className="flex items-center justify-between gap-3 border-b border-border px-3 py-2 last:border-b-0"
                    >
                        <span className="flex min-w-0 flex-col">
                            <span className="text-[12.5px] font-semibold">
                                {PAYMENT_LINE_LABEL[line.method]}
                            </span>
                            <span className="truncate font-mono text-[11px] text-muted-foreground">
                                {paymentReceiptLabel(line)}
                            </span>
                        </span>
                        <span className="text-[12.5px] font-semibold tabular-nums">
                            {formatMoneyCents(line.amountCents)}
                        </span>
                    </li>
                ))}
                <li className="flex items-center justify-between gap-3 bg-muted/50 px-3 py-2">
                    <span className="text-[12.5px] font-semibold">Total cobrado</span>
                    <span className="text-[12.5px] font-bold tabular-nums">
                        {formatMoneyCents(paymentLinesTotalCents(lines))}
                    </span>
                </li>
            </ul>
        </div>
    );
}
